"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
* @namespace ShineOrders
*/
var uniq = require('lodash/uniq');

var _require = require('./classes'),
    getMatchingConstructor = _require.getMatchingConstructor,
    PriceAdjustment = _require.PriceAdjustment,
    Order = _require.Order;

var ShineProducts = require('../products');

var splitOrder = require('./splitOrderByContents');

var convertOrderFromVersionZero = require('./utils/convertOrderFromVersionZero');

var fromEtsyOrderFn = require('./utils/fromEtsyOrder');

var collateJobsFn = require('./utils/collateJobs');

var analyzeRevenue = require('./utils/analyzeRevenue');

var analyzeProducts = require('./utils/analyzeProducts');

var constructors = {
  order: 'order',
  orders: 'order',
  sampleSetsOrder: 'sample sets',
  sampleSetsOrders: 'sample sets',
  testPrintsOrder: 'test prints',
  testPrintsOrders: 'test prints'
};
var defaultParams = {};

var ShineOrders = function ShineOrders() {
  var _instance;

  function init(opts) {
    var options = opts;
    Object.defineProperties(PriceAdjustment.prototype, {
      PRICE_ADJUSTMENTS: {
        value: options.adjustments,
        writable: true
      }
    });

    function makeOrder() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultParams;
      var order_type = params.order_type;
      var Constructor = getMatchingConstructor(order_type);
      var order = new Constructor(params);
      return order;
    }

    var priceAdjustments = {
      make: function make() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return new PriceAdjustment(params);
      }
    };

    function fromVersionZero(params) {
      var order_details = JSON.parse(params.order_details);
      var products = order_details.map(function (prod) {
        return ShineProducts.instance().convert(prod, 0);
      });
      var designer = order_details.map(function (obj) {
        return obj.attr && obj.attr.designer;
      }).filter(function (a) {
        return a;
      })[0];
      var event_date;

      try {
        var event_dates = uniq(products.map(function (obj) {
          return obj.event_date;
        }).filter(function (a) {
          return a;
        }));

        if (event_dates.length > 0) {
          event_date = event_dates[0];

          if (event_dates.length > 1) {
            console.warn('This order had more than one event date');
          }
        }
      } catch (error) {
        console.error(error);
      }

      var new_params = convertOrderFromVersionZero(_objectSpread(_objectSpread({}, params), {}, {
        products: products,
        event_date: event_date,
        designer: designer
      }));
      var order = makeOrder(new_params);

      if (order.has_reprints && !order.reprint_reason) {
        order.reprint_reason = 'ORDERED_VIA_WEBSITE';
      }

      return order;
    }

    function fromEtsyOrder(receipt, transactions) {
      return fromEtsyOrderFn(receipt, transactions, options);
    }

    function updateOptions(newOptions) {
      options = newOptions;
    }

    function splitOrderByContents(order) {
      return splitOrder(order);
    }

    function countries() {
      return options.countries;
    }

    function states() {
      return options.states;
    }

    function getAdjustments() {
      return options.adjustments;
    }
    /**
         * collateJobs returns an array of primary/expected jobs, plus extra jobs categorized by type.
         * @param {Order} order
         * @param {Array<PrintJob|Shipment>} existingJobs - array of existing (not proofing) print jobs or shipments
         * @param {Array<PrintJob|Shipment>} defaultJobs - array of default (proofing) print jobs or shipments
         */


    function collateJobs(order) {
      var existingJobs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var defaultJobs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (!Object.prototype.isPrototypeOf.call(Order.prototype, order)) {
        throw new Error('order must be an instance of Order');
      }

      return collateJobsFn(order, existingJobs, defaultJobs);
    }

    function analyzeDailyRevenue(orders) {
      return analyzeRevenue(orders, 'daily');
    }

    function analyzeWeeklyRevenue(orders) {
      return analyzeRevenue(orders, 'weekly');
    }

    function analyzeMonthlyRevenue(orders) {
      return analyzeRevenue(orders, 'monthly');
    } // function analyzeWeeklyOrders(orders) {
    //     return analyzeOrders()
    // }


    var fns = {
      make: makeOrder,
      updateOptions: updateOptions,
      priceAdjustments: priceAdjustments,
      splitOrderByContents: splitOrderByContents,
      getAdjustments: getAdjustments,
      priceAdjustment: priceAdjustments,
      collateJobs: collateJobs,
      fromVersionZero: fromVersionZero,
      fromEtsyOrder: fromEtsyOrder,
      analyzeDailyRevenue: analyzeDailyRevenue,
      analyzeWeeklyRevenue: analyzeWeeklyRevenue,
      analyzeMonthlyRevenue: analyzeMonthlyRevenue,
      analyzeProducts: analyzeProducts,
      // analyzeWeeklyOrders,
      countries: countries,
      states: states
    };
    Object.keys(constructors).forEach(function (name) {
      fns[name] = {
        make: function make(params) {
          return makeOrder(_objectSpread(_objectSpread({}, params), {}, {
            order_type: constructors[name]
          }));
        }
      };
    });
    return fns;
  }

  return {
    /**
         * initialize
         * @param {*} opts
         * @instance
         * @example
         * import { ShineOrders } from 'shine-products-v2';
         * ShineOrders.initialize(opts);
         */
    initialize: function initialize(opts) {
      _instance = init(opts);
    },

    /**
         * SINGLETON INSTANCE
         * @instance
         * @example
         * import { ShineOrders } from 'shine-products-v2';
         * ShineOrders.instance()
         * // => {
         * //  updatePriceTables
         * //  setPriceTableVersions
         * //  calculatePrice
         * //  calculateSplitFee
         * //  calculatePriceBreakdown
         * //  getPriceTable
         * // }
         */
    instance: function instance() {
      if (!_instance) {
        throw new Error('You must first initialize');
      }

      return _instance;
    }
  };
}();

module.exports = ShineOrders;